var PaymentProviderKey = /* @__PURE__ */ ((PaymentProviderKey2) => {
  PaymentProviderKey2["GtrPay"] = "gtrpay";
  PaymentProviderKey2["TopPay"] = "toppay";
  PaymentProviderKey2["PapayaPay"] = "papaya";
  PaymentProviderKey2["Mint"] = "mint";
  return PaymentProviderKey2;
})(PaymentProviderKey || {});
var DepositMethodType = /* @__PURE__ */ ((DepositMethodType2) => {
  DepositMethodType2["BankTransfer"] = "bank-transfer";
  DepositMethodType2["BankTransferZero"] = "bank-transfer-zero";
  DepositMethodType2["BankTransferNative"] = "bank-transfer-native";
  DepositMethodType2["QrCode"] = "qr-code";
  DepositMethodType2["QrCodeNative"] = "qr-code-native";
  return DepositMethodType2;
})(DepositMethodType || {});
var WithdrawMethodType = /* @__PURE__ */ ((WithdrawMethodType2) => {
  WithdrawMethodType2["BankTransfer"] = "bank-transfer";
  return WithdrawMethodType2;
})(WithdrawMethodType || {});
var MethodBankRequirement = /* @__PURE__ */ ((MethodBankRequirement2) => {
  MethodBankRequirement2["NotRequired"] = "not-required";
  MethodBankRequirement2["Supported"] = "supported";
  MethodBankRequirement2["NotSupported"] = "not-supported";
  return MethodBankRequirement2;
})(MethodBankRequirement || {});
export {
  DepositMethodType,
  MethodBankRequirement,
  PaymentProviderKey,
  WithdrawMethodType
};
